<template>
  <div id="connected-companies">
    <!-- Multiselect Component -->
    <multiselect
      v-model="selected"
      :options="companies"
      :multiple="true"
      :placeholder="$t('Select companies')"
      label="label"
      track-by="id"
    ></multiselect>

    <!-- Hidden Inputs for Form Submission -->
    <input
      v-for="company in selected"
      :key="company.id"
      :value="company.id"
      type="hidden"
      name="companies[]"
    />
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";

export default {
  name: "CompaniesConnect",
  components: {
    Multiselect
  },
  props: {
    selectedIds: {
      type: Array,
      default: () => [] // Fournit un tableau vide par défaut
    },
    companyId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      loading: true,
      companies: [],
      selected: []
    };
  },
  mounted() {
    this.getCompanies().finally(() => {
      this.loading = false;
    });
  },
  watch: {
    selected(newVal) {
      this.$emit("update:selectedIds", newVal.map(company => company.id)); // Émettez uniquement les IDs
    }
  },
  methods: {
    getCompanies() {
      return new Promise(resolve => {
        axios
          .get("/api/companies?noPagination")
          .then(response => {
            // Filter out the current company to avoid self-linking
            this.companies = response.data.data
              .filter(c => {
                // Ignorer self-linking seulement si companyId existe
                return this.companyId
                  ? c.id !== parseInt(this.companyId)
                  : true;
              })
              .map(c => ({
                id: c.id,
                label: `${c.name} (${c.type})` // Créer un label pour l'affichage
              }));

            // Match selected companies with the companies list
            this.selected = this.companies.filter(company =>
              this.selectedIds.includes(company.id)
            );
          })
          .finally(resolve);
      });
    }
  }
};
</script>
